import React, { Component } from 'react';
import Select from 'react-select'
import {customStyles} from "../actions/website-actions";
class SelectBox extends Component {

  constructor(props) {
    super(props);

    this.state = {
      value: props.defaultValue,
      defaultValue: props.defaultValue,
      onChange: props.onChange,
      options: props.options,
      multi: props.multi,
      clearable: props.clearable
    };

    if(typeof props.matchval != "undefined") {
      let opt = props.options.filter((t) => { return t.value == props.matchval});
      //console.log(`Match Was ${props.matchval}`,opt)
      if(opt.length>0) {
        this.state.defaultValue = opt[0]; this.state.value = opt[0];
      }
    }
  }

  handleChange(sel) {
    this.setState({value: sel});
    if(typeof this.props.onChange === "function") {
      this.props.onChange(sel); //Call To Upper Comp...
    }
  }

  render() {


    return (
      <Select
        styles={customStyles}
        isClearable={this.state.clearable}
        isMulti={this.state.multi}
        options={this.props.options}
        onChange={(sel) => {this.handleChange(sel)}} value={this.state.value} defaultValue={this.props.defaultValue}
        placeholder={this.props.placeholder}
        isDisabled={this.props.disabled}
      />
    );
  }
}
export default SelectBox;
